import { useCallback, useEffect, useRef, useState } from "react"
import styles from './index.module.scss'
import { PlusOutlined, LoadingOutlined, DeleteOutlined, CheckCircleFilled, CloseCircleFilled, RightOutlined } from '@ant-design/icons';
import PSAIModal from "@PSAIComponents/PSAIModal";
import { Form, Image, Input, Space, Upload, message } from "antd";
import * as _ from "underscore";
import Utils from '@utils/utils'
import {forwardRef, useImperativeHandle} from 'react'
import API from '@api/api'
import eventBus from '@utils/eventBus';
import CustomModelForm from "../CustomModelForm";

export default function CustomHSFModel (props) {
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const formRef = useRef()

    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await formRef.current.onSubmit()
            if (res) {
                message.success('模特添加成功')
                sessionStorage.setItem('hsf_model_id', res)
                setOpen(false)
                props.onChange()
            }
        } catch (err) {
           message.warning(err.message)
        } finally {
            setLoading(false)
        } 
    }

    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return

        setOpen(true)
    }

    return (
        <>
        <div className={styles.sceneItem} onClick={handleNewModel}>
            <div className={styles.sceneItemContent}>
                {loading ? <LoadingOutlined /> : <PlusOutlined />}
                <p>新增模特</p>
            </div>
        </div>
        <PSAIModal
            title="新增模特"
            maxWidth={586}
            open={open}
            confirmLoading={loading}
            onOk={handelOk}
            onCancel={() => setOpen(false)}
        >
            <CustomModelForm ref={formRef} />
        </PSAIModal>
        </>
    )
}